import { createBrowserRouter } from "react-router-dom";
import { RootLayout } from "./RootLayout";
import { HomePage } from "./screens/HomePage";
import { SearchPage } from "./screens/SearchPage";
import { CustomerPage } from "./screens/CustomerPage";
import { CustomersPage } from "./screens/CustomersPage";
import { DashboardPage } from "./screens/DashboardPage";
import { UsersPage } from "./screens/UsersPage";
import { AuditPage } from "./screens/AuditPage";
import { PoolLayout } from "./screens/pool/PoolLayout";
import { PoolDashboardPage } from "./screens/pool/PoolDashboardPage";
import { PoolIndexRedirect } from "./screens/pool/PoolIndexRedirect";
import { PoolAccountsPage } from "./screens/pool/PoolAccountsPage";
import { PoolUsersPage } from "./screens/pool/PoolUsersPage";
import { PoolIntentsPage } from "./screens/pool/PoolIntentsPage";
import { PoolSettingsPage } from "./screens/pool/PoolSettingsPage";
import { PoolSystemPage } from "./screens/pool/PoolSystemPage";
import { PoolAuditPage } from "./screens/pool/PoolAuditPage";
import { PoolReportsPage } from "./screens/pool/PoolReportsPage";
import { NotFound } from "./NotFound";

/**
 * App route table. RootLayout wraps every route in the AppShell (which owns the Cmd-K omnibox).
 * The AUTH + SEARCH surfaces are real: `/` is the post-auth Home, `/search` is the full-page omnibox.
 * `/worklists` is the Owner/Admin Dashboard (it asserts worklist:read itself), `/customers` is the
 * customers list, and `/customers/:id` is the Customer-360 with its six tabs. `/pool/*` is the Pool
 * module (license/period time-sharing) — gated by a SEPARATE server-side pool role, not RBAC, so
 * PoolLayout itself asserts nothing; each screen renders its own not-an-operator/forbidden state on a
 * 403. Unknown paths render a NotFound screen (not a silent redirect) so a stale/mistyped bookmark gets
 * honest feedback.
 */
export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "search", element: <SearchPage /> },
      { path: "worklists", element: <DashboardPage /> },
      { path: "customers", element: <CustomersPage /> },
      { path: "customers/:id", element: <CustomerPage /> },
      { path: "users", element: <UsersPage /> },
      { path: "audit", element: <AuditPage /> },
      {
        path: "pool",
        element: <PoolLayout />,
        children: [
          { index: true, element: <PoolIndexRedirect /> },
          { path: "dashboard", element: <PoolDashboardPage /> },
          { path: "accounts", element: <PoolAccountsPage /> },
          { path: "users", element: <PoolUsersPage /> },
          { path: "intents", element: <PoolIntentsPage /> },
          { path: "reports", element: <PoolReportsPage /> },
          { path: "settings", element: <PoolSettingsPage /> },
          { path: "system", element: <PoolSystemPage /> },
          { path: "audit", element: <PoolAuditPage /> },
        ],
      },
      { path: "*", element: <NotFound /> },
    ],
  },
]);
